import {
    FaShoppingCart,
    FaCloud,
    FaHospital,
    FaChartLine,
    FaRocket,
    FaBuilding,
    FaBook,
    FaHotel
} from "react-icons/fa";

export default function Section8() {
    const industries = [
        {
            title: "Ecommerce & Retail",
            text: "Rank products and increase sales",
            icon: <FaShoppingCart className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "SaaS & Technology",
            text: "Drive qualified leads to software and digital services",
            icon: <FaCloud className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Healthcare & Medical",
            text: "Attract patients and increase visibility in local search",
            icon: <FaHospital className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Finance & FinTech",
            text: "Build credibility and attract clients online",
            icon: <FaChartLine className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Startups & SMEs",
            text: "Compete with larger businesses with targeted SEO campaigns",
            icon: <FaRocket className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Agencies & Enterprises",
            text: "Multi-location SEO strategies for large-scale growth",
            icon: <FaBuilding className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Education & E-Learning",
            text: "Boost course registrations and enrollment",
            icon: <FaBook className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Hospitality & Travel",
            text: "Increase bookings and inquiries with optimized pages",
            icon: <FaHotel className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        }
    ];

    return (
        <div className="Section8 py-[60px] md:py-[100px] bg-[#f9f9f9]">
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    SEO Solutions for Every Industry 
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Tailored SEO strategies for businesses across different industries to increase traffic, leads, and revenue.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {industries.map((industry, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
                    >
                        {/* Icon */}
                        <div className="mb-4">{industry.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {industry.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-600 text-sm md:text-base">{industry.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
